import type { ServiceKey } from './config';

/**
 * `[<service>, <resource>, <scope?>, <id-or-filter?>]` — mirroring the REST
 * URL, never invented per feature. Centralised here so a mutation's
 * invalidation set is written against the same tuple the query registered
 * (PRD-TDD §10.2).
 *
 * Each feature adds its own resources by calling `key()`; the factory does not
 * enumerate resources, because a list here would go stale the moment a feature
 * lands without touching this file.
 */
export type QueryKey = readonly [ServiceKey, string, ...unknown[]];

export function key(service: ServiceKey, resource: string, ...rest: unknown[]): QueryKey {
  return [service, resource, ...rest] as const;
}

/**
 * `staleTime` defaults, in milliseconds. A queue's depth is what an operator
 * came back to the tab for; a vocabulary changes about once a quarter; a detail
 * route must reflect the decision that was just taken.
 */
export const STALE_TIME = {
  /** Queues and lists. */
  list: 30_000,
  /** Configuration reads and vocabularies. */
  vocabulary: 5 * 60_000,
  /** Detail routes. */
  detail: 0,
} as const;

export const GC_TIME = 5 * 60_000;
